import React, {useEffect, useState} from "react";
import { useIntl } from 'react-intl';

// Components
import { Form, ToggleSwitch } from 'Components';
import TriggerLandmark from "Modules/alerts/components/wizardAlert/common/components/TriggerLandmark";


export const Media = (props) => {

    const { value, onChange, formRef, triggers, triggersRaw } = props
    const { messages } = useIntl()
    const [showErrorTrigger, setShowErrorTrigger] = useState(false)

    useEffect(() => {
        if (value.impactDetected == undefined)
            onChange({
                ...value,
                impactDetected: false,
                panicButton: false,
            })
    }, [value])

    return (
        <Form ref={formRef}
            onSubmit={() => {
                if (value.trigger) {
                    let isValid = triggersRaw?.length > 0

                    if (!isValid) {
                        setShowErrorTrigger(true)
                    } else setShowErrorTrigger(false)
                    return isValid && (value.impactDetected || value.panicButton)
                } else {
                    return value.impactDetected || value.panicButton;
                }
            }}
        >
            <div className="form-item" style={{ padding: "10px 0" }}>
                <label className="input-normal-label">{messages['alertsNewAlert_triggersLabel']}<span className="text-danger"> *</span></label>
                {
                    (!value.impactDetected && !value.panicButton) &&
                    <div className="text-danger">
                        {messages["alertsNewAlert_triggerValidation"]}
                    </div>
                }

                <div style={{ paddingTop: 10 }}>
                    <ToggleSwitch
                        id="impactDetected"
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_impactDetectedLabel']}
                        checked={value.impactDetected ? true : false}
                        onChange={(event) => {
                            onChange({ ...value, impactDetected: event })
                        }}
                    />
                </div>

                <div style={{ paddingTop: 10 }}>
                    <ToggleSwitch
                        id="panicButton"
                        small
                        blueToggle
                        optionLabels={["", ""]}
                        label={messages['alertsNewAlert_panicButtonLabel']}
                        checked={value.panicButton ? true : false}
                        onChange={(event) => {
                            onChange({ ...value, panicButton: event })
                        }}
                    />
                </div>
                <div style={{paddingTop:25}}>
                    <TriggerLandmark config={value} triggers={triggers} triggersRaw={triggersRaw} onChange={onChange} showErrorTrigger={showErrorTrigger} />
                </div>
            </div>
        </Form>
    );
}
